"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailFailuresSegmentation = void 0;
var EmailFailuresSegmentation;
(function (EmailFailuresSegmentation) {
    let reason;
    (function (reason) {
        reason["INVALID_EMAIL"] = "invalid_email";
        reason["RECEIVED_EMAIL_IN_THE_LAST_2_DAYS"] = "received_email_in_the_last_2_days";
        reason["SPECIAL_OFFERS_DISABLED"] = "special_offers_disabled";
        reason["NO_SPONSORSHIPS"] = "no_sponsorships";
        reason["NO_SPECIAL_SPONSORSHIP"] = "no_special_sponsorship";
        reason["NO_ADVERTISERS"] = "no_advertisers";
        reason["NO_TEMPLATE"] = "no_template";
        reason["HAS_ACCEPTED_RUNNING_SPONSORSHIP"] = "has_accepted_running_sponsorship";
        reason["RECEIVED_DIGEST_EMAIL_IN_THE_LAST_3_DAYS"] = "received_digest_email_in_the_last_3_days";
        reason["DIGEST_DISABLED"] = "digest_disabled";
        reason["NOT_ELIGIBLE_FOR_EMAILS"] = "not_eligible_for_emails";
        reason["RECEIVED_EMAIL_IN_THE_LAST_DAY"] = "received_email_in_the_last_day";
    })(reason = EmailFailuresSegmentation.reason || (EmailFailuresSegmentation.reason = {}));
})(EmailFailuresSegmentation = exports.EmailFailuresSegmentation || (exports.EmailFailuresSegmentation = {}));
